import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-32 bg-white" data-id="element-13">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 items-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative" data-id="element-15">
          <div className="aspect-[3/4] w-full max-w-md mx-auto relative group" data-id="element-16">
            <div className="w-full h-full bg-surface border border-line rounded-[2.5rem] shadow-xl flex items-center justify-center overflow-hidden transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-17">
              <div className="text-center" data-id="element-18">
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-19">
                  Портрет майстра
                </p>
              </div>
            </div>
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-white rounded-full flex items-center justify-center border border-line shadow-xl z-10" data-id="element-20">
              <div className="text-center" data-id="element-21">
                <span className="block font-heading text-3xl font-bold text-ink" data-id="element-22">
                  12+
                </span>
                <span className="text-[10px] uppercase tracking-widest font-medium text-muted mt-1" data-id="element-23">
                  років
                </span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-24">
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-25">
            Про мене
          </h2>
          <div className="w-12 h-1 bg-ink rounded-full mb-8" data-id="element-26"></div>

          <div className="space-y-6 text-muted font-normal text-lg leading-relaxed" data-id="element-27">
            <p data-id="element-28">
              Привіт! Я Валентина — майстер-перукар та колорист з понад
              12-річним досвідом. Моя місія — не просто змінити вашу зачіску, а
              підкреслити вашу індивідуальність та природну красу.
            </p>
            <p data-id="element-29">
              Я постійно навчаюсь, відвідую міжнародні майстер-класи та слідкую
              за останніми трендами у світі б'юті-індустрії. Для мене важливо
              використовувати лише якісні та безпечні матеріали, щоб ваше
              волосся завжди виглядало здоровим та доглянутим.
            </p>
            <div className="bg-surface p-8 rounded-[2rem] border border-line mt-8" data-id="element-30">
              <p className="italic text-ink font-medium text-xl leading-relaxed" data-id="element-31">
                "Краса волосся починається з його здоров'я. Моя мета — навчити
                вас любити своє волосся та правильно за ним доглядати."
              </p>
            </div>
          </div>

          <div className="mt-12" data-id="element-32">
            <div className="h-12 w-32 border-b-2 border-ink flex items-end pb-2" data-id="element-33">
              <span className="text-[10px] text-ink font-bold uppercase tracking-widest" data-id="element-34">
                Підпис
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}